import type { OrganizationsList } from '@openx/types/organization.ts';

export const buildAccountHierarchy = (
  id: string,
  name: string,
  path_to_root: string[],
  parentOrganizations: Pick<OrganizationsList, 'id' | 'name'>[]
): { name: string; id: string }[] =>
  path_to_root
    .map(parentOrganizationId => {
      const ancestor = parentOrganizations.find(org => org.id === parentOrganizationId);
      return ancestor
        ? { name: ancestor.name, id: ancestor.id }
        : { name: parentOrganizationId, id: parentOrganizationId };
    })
    .concat({ name, id });
